<template>
  <el-dialog
    :model-value="isOpen"
    title="Invite Talent"
    width="500px"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <el-form
        @submit.prevent
        class="App-Styled-Form"
        :label-position="'top'"
        label-width="100px"
        :model="form"
        style="margin-top: 12px"
      >
        <!--  -->
        <p txt-center>
          Type the email of the <br />
          person to send an invitation to.
        </p>
        <!-- Email -->
        <el-form-item prop="email" label="Email">
          <template v-slot:label>
            <el-icon>
              <Message />
            </el-icon>
            Email
          </template>
          <el-input
            placeholder="johndoe@e4t.com"
            v-model="form.email"
          ></el-input>
        </el-form-item>
        <!--  -->
      </el-form>
    </div>
    <!--  -->
    <template #footer>
      <div txt-center class="dialog-footer">
        <el-button
          @click="sendInvitation"
          :loading="loading"
          :disabled="loading"
          icon="el-icon-position"
          size="large"
          type="primary"
        >
          Send Invitation
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Invitation, User } from "@/shared/interfaces";
import { Options, Vue } from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { Lock, Message } from "@element-plus/icons";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorUtil } from "@/shared";

@Options({
  components: { Message },
})
export default class extends Vue {
  /**
   *
   */
  @Prop({ type: Boolean }) isOpen!: boolean;
  /**
   * Form data
   */
  form = { email: undefined };
  loading = false;

  /**
   * @sends the login request to the API
   */
  sendInvitation(): void {
    this.loading = true;
    this.$api.admin
      .post("/v1/invitations", this.form)
      .then((resp: AxiosResponse<Invitation>) => {
        this.$store.dispatch("invitations/fetch");
        this.handleClose();
      })
      .catch((err: AxiosError) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /**
   * For closing the modal
   */
  @Emit("close")
  handleClose() {
    console.log("should close");
  }
}
</script>

<style lang="scss"></style>
